module.exports = __webpack_public_path__ + "open-sans-latin-600italic.1e111aadc438b7b75734.woff2";


//////////////////
// WEBPACK FOOTER
// /Users/herbert/dev/awesum/awesum-web/~/typeface-open-sans/files/open-sans-latin-600italic.woff2
// module id = ../../../../typeface-open-sans/files/open-sans-latin-600italic.woff2
// module chunks = 1 3